export enum HttpStatusCodeEnum {
  OK = 200,
  Created = 201,
  Accepted = 202,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  Gone = 410,
  UnprocessableEntity = 422,
  Locked = 423,
  InternalServerError = 500,
}

export const API_PREFIX = "/task-management/api/v1/external"
export const MP_AUTH_API_PREFIX = `/mp-auth/api/v1/external`
export const NOTIFICATION_API_PREFIX =
  "/task-management/api/v1/external/notification"
export const AUTH_API_PREFIX = "/task-management/api/v1/external/auth"
export const PROJECTS_API_PREFIX = "/task-management/api/v1/external/projects"
export const MANUAL_JOBS_PREFIX = `/task-management/api/v1/external/manual-jobs`
export const ANONYMOUS_PROJECTS_API_PREFIX =
  "/task-management/api/v1/external/anonymous/projects"
export const MT_API_PREFIX = "/task-management/api/v1/external/mt"
export const ADMIN_API_PREFIX = "/task-management/api/v1/external/admin"
export const PROMOTIONS_API_PREFIX =
  "/task-management/api/v1/external/promotions"
export const GLOSSARY_API_PREFIX = "/task-management/api/v1/external/glossaries"
export const FEEDBACK_API_PREFIX = "/task-management/api/v1/external/feedback"
export const WORKSPACE_API_PREFIX = "/workspace/api/v1/external/workspaces"

export const ADMIN_BILLING_API_PREFIX = `/task-management/api/v1/external/admin/billing`

export const BILLING_MP_SUBSCRIPTIONS_API_PREFIX = `/task-management/api/v1/external/billing/mp-subscriptions`
export const MP_SUBSCRIPTIONS_API_PREFIX = `/task-management/api/v1/external/mp-subscriptions`
export const BILLING_API_PREFIX = `/task-management/api/v1/external/billing`
export const API_SUBSCRIPTIONS_PREFIX = `/task-management/api/v1/external/api-subscriptions`
